export default __webpack_public_path__ + "static/media/calendar.c1e50bf3.svg";